export default "/JMMMU/health_medicine.3838bd3c-1cc525.jpg";